
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/certification/[postId]",
      function () {
        return require("private-next-pages/certification/[postId]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/certification/[postId]"])
      });
    }
  